import { Reveal } from '../hooks/useReveal'

export const About = ({ profile }) => (
  <section className="section" id="about">
    <div className="container about__grid">
      <Reveal>
        <p className="eyebrow">About</p>
        <h2 className="section-title">
          From firmware
          <br />
          to the cloud.
        </h2>
      </Reveal>

      <Reveal delay={100} className="about__body">
        <p>{profile.summary}</p>
        <p>{profile.summary2}</p>
      </Reveal>
    </div>
  </section>
)
